var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DSticker5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 298,
    viewBox: "0 0 435 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_2121_3016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.087 78.9475C493.442 62.2424 472.081 56.5188 455.376 66.1635C438.671 75.8082 432.948 97.1689 442.592 113.874C452.237 130.579 473.598 136.303 490.303 126.658C507.008 117.013 512.732 95.6525 503.087 78.9475Z",
    fill: "url(#paint0_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.237 93.6584C481.575 76.9242 460.178 71.1907 443.443 80.8522C426.709 90.5136 420.976 111.911 430.637 128.646C440.299 145.38 461.697 151.113 478.431 141.452C495.165 131.79 500.898 110.392 491.237 93.6584Z",
    fill: "url(#paint1_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.837 108.844C471.158 92.0785 449.72 86.3342 432.954 96.0138C416.189 105.693 410.444 127.132 420.124 143.897C429.804 160.663 451.242 166.407 468.007 156.727C484.773 147.048 490.517 125.61 480.837 108.844Z",
    fill: "url(#paint2_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.962 124.387C462.266 107.592 440.79 101.838 423.996 111.534C407.201 121.231 401.447 142.706 411.143 159.501C420.84 176.295 442.315 182.05 459.11 172.353C475.904 162.657 481.659 141.182 471.962 124.387Z",
    fill: "url(#paint3_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.704 140.133C454.991 123.309 433.478 117.545 416.655 127.258C399.831 136.971 394.067 158.484 403.78 175.307C413.493 192.131 435.006 197.895 451.829 188.182C468.653 178.469 474.417 156.957 464.704 140.133Z",
    fill: "url(#paint4_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.141 155.956C449.41 139.1 427.858 133.325 411.002 143.057C394.147 152.788 388.372 174.341 398.103 191.196C407.835 208.051 429.387 213.826 446.243 204.095C463.098 194.363 468.873 172.811 459.141 155.956Z",
    fill: "url(#paint5_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.352 171.717C445.604 154.833 424.014 149.048 407.13 158.796C390.246 168.544 384.461 190.134 394.209 207.018C403.957 223.902 425.547 229.687 442.431 219.939C459.315 210.191 465.1 188.601 455.352 171.717Z",
    fill: "url(#paint6_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.417 187.28C443.652 170.366 422.025 164.571 405.112 174.336C388.199 184.101 382.404 205.728 392.169 222.641C401.934 239.555 423.561 245.35 440.474 235.585C457.387 225.82 463.182 204.193 453.417 187.28Z",
    fill: "url(#paint7_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.433 202.504C443.65 185.56 421.983 179.754 405.038 189.537C388.093 199.32 382.287 220.987 392.07 237.932C401.853 254.877 423.521 260.683 440.465 250.899C457.41 241.116 463.216 219.449 453.433 202.504Z",
    fill: "url(#paint8_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.457 217.258C445.657 200.284 423.953 194.469 406.979 204.269C390.005 214.068 384.189 235.773 393.989 252.747C403.789 269.72 425.493 275.536 442.467 265.736C459.441 255.936 465.257 234.232 455.457 217.258Z",
    fill: "url(#paint9_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.588 231.411C449.772 214.408 428.03 208.582 411.027 218.399C394.024 228.215 388.199 249.957 398.015 266.96C407.832 283.963 429.574 289.788 446.577 279.972C463.579 270.155 469.405 248.413 459.588 231.411Z",
    fill: "url(#paint10_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.904 244.811C456.069 227.777 434.287 221.94 417.253 231.775C400.219 241.61 394.382 263.392 404.217 280.426C414.052 297.46 435.833 303.297 452.868 293.462C469.902 283.627 475.739 261.846 465.904 244.811Z",
    fill: "url(#paint11_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.106 259.624C463.254 242.56 441.435 236.714 424.372 246.565C407.308 256.417 401.462 278.236 411.314 295.299C421.165 312.363 442.984 318.209 460.047 308.357C477.111 298.506 482.957 276.687 473.106 259.624Z",
    fill: "url(#paint12_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.801 275.338C467.932 258.246 446.076 252.39 428.984 262.258C411.891 272.126 406.035 293.982 415.903 311.075C425.772 328.167 447.628 334.024 464.72 324.155C481.813 314.287 487.669 292.431 477.801 275.338Z",
    fill: "url(#paint13_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.025 291.708C470.139 274.584 448.242 268.717 431.118 278.603C413.994 288.49 408.127 310.386 418.014 327.51C427.9 344.634 449.797 350.501 466.921 340.615C484.045 330.728 489.912 308.832 480.025 291.708Z",
    fill: "url(#paint14_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.853 308.559C469.95 291.406 448.016 285.529 430.863 295.432C413.71 305.336 407.833 327.269 417.736 344.422C427.64 361.575 449.573 367.452 466.726 357.549C483.879 347.646 489.756 325.712 479.853 308.559Z",
    fill: "url(#paint15_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.364 325.735C467.444 308.553 445.474 302.666 428.292 312.586C411.11 322.506 405.223 344.477 415.143 361.659C425.063 378.841 447.033 384.728 464.215 374.808C481.397 364.888 487.284 342.917 477.364 325.735Z",
    fill: "url(#paint16_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.102 322.169C186.751 304.241 163.827 298.099 145.899 308.449C127.971 318.8 121.829 341.724 132.179 359.652C142.53 377.58 165.454 383.722 183.382 373.372C201.31 363.021 207.453 340.097 197.102 322.169Z",
    fill: "url(#paint17_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.054 304.763C190.686 286.806 167.725 280.653 149.768 291.021C131.811 301.388 125.659 324.35 136.026 342.306C146.393 360.263 169.355 366.416 187.312 356.048C205.269 345.681 211.421 322.72 201.054 304.763Z",
    fill: "url(#paint18_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.939 287.945C196.554 269.956 173.552 263.793 155.564 274.179C137.575 284.564 131.412 307.566 141.798 325.554C152.183 343.543 175.185 349.706 193.173 339.32C211.162 328.935 217.325 305.933 206.939 287.945Z",
    fill: "url(#paint19_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.398 272.249C203.996 254.232 180.957 248.059 162.939 258.461C144.922 268.863 138.749 291.902 149.151 309.92C159.554 327.937 182.592 334.11 200.61 323.708C218.627 313.305 224.8 290.267 214.398 272.249Z",
    fill: "url(#paint20_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.351 257.624C212.932 239.578 189.856 233.394 171.809 243.814C153.763 254.233 147.58 277.309 157.999 295.355C168.418 313.402 191.494 319.585 209.54 309.166C227.587 298.747 233.77 275.671 223.351 257.624Z",
    fill: "url(#paint21_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.678 244.142C223.241 226.064 200.125 219.87 182.047 230.307C163.969 240.745 157.775 263.861 168.212 281.939C178.649 300.017 201.765 306.211 219.843 295.773C237.921 285.336 244.115 262.22 233.678 244.142Z",
    fill: "url(#paint22_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.254 231.896C234.8 213.789 211.646 207.585 193.539 218.039C175.432 228.493 169.228 251.646 179.683 269.753C190.137 287.86 213.29 294.064 231.397 283.61C249.504 273.156 255.708 250.003 245.254 231.896Z",
    fill: "url(#paint23_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.956 220.946C247.485 202.81 224.294 196.596 206.158 207.067C188.022 217.538 181.808 240.729 192.279 258.865C202.75 277.001 225.94 283.215 244.077 272.744C262.213 262.273 268.427 239.083 257.956 220.946Z",
    fill: "url(#paint24_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.669 211.378C261.18 193.211 237.949 186.986 219.781 197.475C201.614 207.964 195.389 231.195 205.878 249.363C216.367 267.53 239.598 273.755 257.765 263.266C275.933 252.777 282.158 229.546 271.669 211.378Z",
    fill: "url(#paint25_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.263 203.273C275.757 185.076 252.489 178.842 234.293 189.347C216.096 199.853 209.861 223.121 220.367 241.318C230.873 259.514 254.141 265.749 272.338 255.243C290.534 244.737 296.769 221.469 286.263 203.273Z",
    fill: "url(#paint26_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.613 196.702C291.091 178.477 267.786 172.232 249.56 182.755C231.334 193.277 225.09 216.582 235.612 234.808C246.135 253.034 269.44 259.278 287.666 248.756C305.891 238.233 312.136 214.928 301.613 196.702Z",
    fill: "url(#paint27_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.614 191.744C307.073 173.486 283.728 167.231 265.471 177.772C247.214 188.313 240.958 211.658 251.499 229.915C262.04 248.172 285.385 254.428 303.642 243.887C321.9 233.346 328.155 210.001 317.614 191.744Z",
    fill: "url(#paint28_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.128 188.482C323.57 170.196 300.188 163.93 281.901 174.488C263.615 185.045 257.35 208.428 267.907 226.714C278.465 245 301.847 251.266 320.134 240.708C338.42 230.151 344.685 206.768 334.128 188.482Z",
    fill: "url(#paint29_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.042 186.986C340.468 168.67 317.048 162.395 298.733 172.969C280.418 183.544 274.142 206.963 284.717 225.279C295.291 243.594 318.711 249.869 337.026 239.295C355.341 228.721 361.617 205.301 351.042 186.986Z",
    fill: "url(#paint30_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.228 187.341C357.637 168.997 334.181 162.711 315.836 173.303C297.492 183.894 291.207 207.35 301.798 225.695C312.389 244.039 335.846 250.324 354.19 239.733C372.534 229.142 378.82 205.685 368.228 187.341Z",
    fill: "url(#paint31_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.575 189.613C374.966 171.237 351.469 164.941 333.093 175.55C314.717 186.16 308.421 209.657 319.03 228.032C329.64 246.408 353.137 252.704 371.513 242.095C389.888 231.486 396.184 207.989 385.575 189.613Z",
    fill: "url(#paint32_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.015 193.929C392.389 175.524 368.855 169.218 350.45 179.844C332.045 190.47 325.739 214.005 336.365 232.409C346.991 250.814 370.526 257.12 388.93 246.494C407.335 235.868 413.641 212.334 403.015 193.929Z",
    fill: "url(#paint33_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.356 200.14C408.713 181.706 385.141 175.39 366.708 186.033C348.274 196.676 341.958 220.247 352.601 238.681C363.243 257.115 386.815 263.431 405.249 252.788C423.683 242.145 429.998 218.574 419.356 200.14Z",
    fill: "url(#paint34_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.282 208.193C423.621 189.728 400.01 183.401 381.544 194.062C363.079 204.723 356.752 228.334 367.413 246.8C378.074 265.265 401.686 271.592 420.151 260.931C438.617 250.27 444.943 226.658 434.282 208.193Z",
    fill: "url(#paint35_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.602 218.083C436.925 199.589 413.276 193.252 394.781 203.93C376.287 214.608 369.95 238.257 380.628 256.751C391.306 275.246 414.955 281.582 433.449 270.904C451.944 260.227 458.28 236.578 447.602 218.083Z",
    fill: "url(#paint36_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.134 229.783C448.44 211.259 424.754 204.912 406.23 215.607C387.707 226.302 381.36 249.988 392.055 268.511C402.749 287.035 426.435 293.381 444.959 282.687C463.482 271.992 469.829 248.306 459.134 229.783Z",
    fill: "url(#paint37_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.693 243.281C457.98 224.726 434.254 218.368 415.699 229.081C397.144 239.794 390.787 263.52 401.499 282.075C412.212 300.63 435.938 306.987 454.493 296.275C473.048 285.562 479.406 261.836 468.693 243.281Z",
    fill: "url(#paint38_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.17 255.628C466.441 237.044 442.677 230.677 424.093 241.407C405.509 252.136 399.142 275.899 409.871 294.483C420.601 313.067 444.364 319.435 462.948 308.705C481.532 297.976 487.9 274.212 477.17 255.628Z",
    fill: "url(#paint39_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.348 266.32C476.601 247.707 452.801 241.329 434.188 252.076C415.575 262.822 409.197 286.622 419.944 305.235C430.69 323.849 454.49 330.226 473.103 319.48C491.716 308.733 498.094 284.933 487.348 266.32Z",
    fill: "url(#paint40_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.111 275.416C488.347 256.771 464.506 250.383 445.861 261.148C427.217 271.912 420.829 295.753 431.593 314.397C442.358 333.042 466.198 339.43 484.843 328.665C503.488 317.901 509.876 294.06 499.111 275.416Z",
    fill: "url(#paint41_linear_2121_3016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.301 282.939C501.52 264.265 477.642 257.867 458.969 268.649C440.295 279.43 433.897 303.308 444.678 321.981C455.459 340.655 479.337 347.053 498.011 336.272C516.684 325.491 523.083 301.613 512.301 282.939Z",
    fill: "url(#paint42_linear_2121_3016)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2121_3016",
    x1: 449.95,
    y1: 122.849,
    x2: 495.864,
    y2: 70.1987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2121_3016",
    x1: 440.002,
    y1: 139.188,
    x2: 481.853,
    y2: 83.1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2121_3016",
    x1: 431.745,
    y1: 155.959,
    x2: 469.093,
    y2: 96.6291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2121_3016",
    x1: 425.374,
    y1: 173.089,
    x2: 457.684,
    y2: 110.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2121_3016",
    x1: 420.852,
    y1: 190.204,
    x2: 447.491,
    y2: 125.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2121_3016",
    x1: 418.45,
    y1: 207.275,
    x2: 438.668,
    y2: 139.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2121_3016",
    x1: 418.372,
    y1: 224.11,
    x2: 431.299,
    y2: 154.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2121_3016",
    x1: 420.468,
    y1: 240.256,
    x2: 425.168,
    y2: 169.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2121_3016",
    x1: 425.086,
    y1: 255.624,
    x2: 420.612,
    y2: 184.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2121_3016",
    x1: 431.835,
    y1: 269.709,
    x2: 417.405,
    y2: 200.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2121_3016",
    x1: 441.323,
    y1: 282.516,
    x2: 416.482,
    y2: 215.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2121_3016",
    x1: 452.45,
    y1: 293.578,
    x2: 417.323,
    y2: 231.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2121_3016",
    x1: 454.995,
    y1: 310.756,
    x2: 429.39,
    y2: 244.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2121_3016",
    x1: 454.259,
    y1: 328.191,
    x2: 439.521,
    y2: 258.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2121_3016",
    x1: 451.053,
    y1: 345.333,
    x2: 446.944,
    y2: 273.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2121_3016",
    x1: 445.797,
    y1: 362.154,
    x2: 451.649,
    y2: 290.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2121_3016",
    x1: 438.693,
    y1: 378.687,
    x2: 453.619,
    y2: 308.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2121_3016",
    x1: 170.6,
    y1: 304.097,
    x2: 158.718,
    y2: 378.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2121_3016",
    x1: 178.897,
    y1: 287.313,
    x2: 158.188,
    y2: 359.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2121_3016",
    x1: 188.606,
    y1: 271.986,
    x2: 160.114,
    y2: 341.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2121_3016",
    x1: 199.682,
    y1: 257.884,
    x2: 163.894,
    y2: 324.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2121_3016",
    x1: 212.073,
    y1: 245.152,
    x2: 169.45,
    y2: 307.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2121_3016",
    x1: 225.407,
    y1: 234.271,
    x2: 176.456,
    y2: 291.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2121_3016",
    x1: 239.79,
    y1: 224.708,
    x2: 185.078,
    y2: 277.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2121_3016",
    x1: 255.183,
    y1: 216.488,
    x2: 195.308,
    y2: 263.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2121_3016",
    x1: 270.966,
    y1: 210.27,
    x2: 206.538,
    y2: 250.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2121_3016",
    x1: 287.299,
    y1: 205.682,
    x2: 218.968,
    y2: 239.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2121_3016",
    x1: 304.491,
    y1: 202.558,
    x2: 232.953,
    y2: 228.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2121_3016",
    x1: 321.637,
    y1: 201.467,
    x2: 247.619,
    y2: 220.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2121_3016",
    x1: 338.91,
    y1: 202.228,
    x2: 263.2,
    y2: 212.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2121_3016",
    x1: 355.92,
    y1: 204.921,
    x2: 279.375,
    y2: 207.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2121_3016",
    x1: 373.287,
    y1: 209.47,
    x2: 296.802,
    y2: 203.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2121_3016",
    x1: 390.079,
    y1: 216.003,
    x2: 314.593,
    y2: 201.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2121_3016",
    x1: 406.196,
    y1: 224.635,
    x2: 332.761,
    y2: 201.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2121_3016",
    x1: 420.915,
    y1: 235.454,
    x2: 350.858,
    y2: 203.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2121_3016",
    x1: 433.279,
    y1: 248.22,
    x2: 368.208,
    y2: 206.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2121_3016",
    x1: 443.43,
    y1: 262.995,
    x2: 385.171,
    y2: 212.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2121_3016",
    x1: 450.233,
    y1: 278.753,
    x2: 400.67,
    y2: 219.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2121_3016",
    x1: 454.728,
    y1: 296.179,
    x2: 415.501,
    y2: 229.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2121_3016",
    x1: 467.844,
    y1: 305.238,
    x2: 419.076,
    y2: 244.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2121_3016",
    x1: 482.448,
    y1: 311.89,
    x2: 424.787,
    y2: 259.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2121_3016",
    x1: 497.706,
    y1: 316.587,
    x2: 432.943,
    y2: 273.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2121_3016",
    x1: 513.287,
    y1: 319.551,
    x2: 443.201,
    y2: 285.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121_3016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 546.754,
    height: 546.754,
    fill: "white",
    transform: "translate(274 673.555) rotate(-120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DSticker5);
export default __webpack_public_path__ + "static/media/3d-sticker5.5e5739703d2ac15187b62d8df05d12c1.svg";
export { ForwardRef as ReactComponent };